/* terminal/actions */
import { action } from "typesafe-actions";
import { ApplicationActionTypes, Application, Version } from "./types";

export const fetchRequest = (
  // id?: string | null,
  // params?: {},
  callback?: (data: Array<string>) => unknown | null
) => {
  return action(ApplicationActionTypes.FETCH, { callback });
};

export const fetchSuccess = (application: Application) =>
  action(ApplicationActionTypes.FETCH_SUCCESS, application);

export const fetchError = (error: string) =>
  action(ApplicationActionTypes.FETCH_ERROR, error);

export const fetchVersion = (
  application: string,
  // params?: {},
  callback?: () => unknown | null
) => {
  return action(ApplicationActionTypes.FETCH_VERSION, { application, callback });
};

export const fetchVersionSuccess = (version: Version) =>
  action(ApplicationActionTypes.FETCH_VERSION_SUCCESS, version);

export const fetchVersionError = (error: string) =>
  action(ApplicationActionTypes.FETCH_VERSION_ERROR, error);


export const fetchFirmware = (
  params: { variant: string; model: string; },
  callback?: (data: Array<string>) => unknown | null
) => {
  return action(ApplicationActionTypes.FETCH_FIRMWARE, { params, callback });
};

export const fetchFirmwareSuccess = (model: string, version: Version) =>
  action(ApplicationActionTypes.FETCH_FIRMWARE_SUCCESS, { model, version });

export const fetchFirmwareError = (error: string) =>
  action(ApplicationActionTypes.FETCH_FIRMWARE_ERROR, error);
